import { render, staticRenderFns } from "./bayDone.vue?vue&type=template&id=8c50979e&"
import script from "./bayDone.vue?vue&type=script&lang=js&"
export * from "./bayDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports